import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Box, ThemeContainer, ThemeProvider} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {AiFill} from '@dropbox/dig-icons/assets';
import {derivedThemeAtom} from 'atoms/layout';
import {RichTextArea} from 'components/DSYS/RichTextArea';
import {useAtomValue} from 'jotai';
import {AIRule} from 'plugins/aiRules';

export const AISuggestionDisplay = ({
  suggestedText,
  isGenerating = false,
  rule,
  onAccept,
  onReject,
  toolbarRef,
}: {
  suggestedText: string;
  isGenerating?: boolean;
  rule?: AIRule;
  onAccept: () => void;
  onReject: () => void;
  toolbarRef?: React.RefObject<HTMLDivElement>;
}) => {
  const isDarkMode = useAtomValue(derivedThemeAtom) === 'dark';
  const isCustomAIRule = rule && !['spelling', 'grammar'].includes(rule.id);

  return (
    <ThemeProvider mode={!isDarkMode ? 'dark' : 'bright'}>
      <ThemeContainer>
        <Box
          display="flex"
          flexDirection="row"
          style={{
            gap: 16,
            width: isGenerating ? undefined : 550,
          }}
        >
          <Box
            ref={toolbarRef}
            boxShadow="Floating"
            backgroundColor="Background Base"
            borderRadius="Large"
          >
            <Box padding="12" paddingRight="20" display="flex" alignItems="center" style={{gap: 2}}>
              <UIIcon src={AiFill} />
              <Text isBold>{isGenerating ? 'AI is generating…' : (rule?.name ?? 'Suggested')}</Text>
            </Box>
            {!isGenerating && (
              <ThemeProvider mode={isDarkMode ? 'dark' : 'bright'}>
                <ThemeContainer>
                  <Box
                    backgroundColor="Background Base"
                    borderStyle="Solid"
                    borderColor="Border Subtle"
                    display="flex"
                    flexDirection="column"
                    borderWidth="1"
                    padding="12"
                    style={{
                      gap: 12,
                      minWidth: 550,
                      borderTop: 'none',
                      borderBottomLeftRadius: 12,
                      borderBottomRightRadius: 12,
                    }}
                  >
                    {isCustomAIRule ? (
                      <Text>{rule.rule}</Text>
                    ) : (
                      <RichTextArea
                        editable={false}
                        squareBorders
                        value={suggestedText}
                        table
                        // theme="paper"
                      />
                    )}

                    {isCustomAIRule ? (
                      <Box display="flex" flexDirection="row" style={{gap: 8}}>
                        <Button variant="outline" size="small" onClick={onReject}>
                          Ignore
                        </Button>
                      </Box>
                    ) : (
                      <Box display="flex" flexDirection="row" style={{gap: 8}}>
                        <Button variant="opacity" size="small" onClick={onAccept}>
                          Accept
                        </Button>
                        <Button variant="outline" size="small" onClick={onReject}>
                          Reject
                        </Button>
                      </Box>
                    )}
                  </Box>
                </ThemeContainer>
              </ThemeProvider>
            )}
          </Box>
        </Box>
      </ThemeContainer>
    </ThemeProvider>
  );
};
